const CollaborationNoteEditorComponent = {
    templateUrl: '/collaboration/note/collaborationNoteEditor.tpl.html',
    controller: 'collaborationNoteEditorController',
    bindings: {
        canDelete: '<',
        canModify: '<',
        canModifyOtherUserOptions: '<',
        canEditShare: '<',
        isAuthor: '<',
        isExistingNote: '<',
        isUnderwriterUser: '<',
        note: '<',
        onCloseNoteEditor: '&',
        onCreateNote: '&',
        onDeleteNote: '&',
        onGetDisplayedTime: '&',
        onUpdateNote: '&',
        viewModel: '<'
    }
};

angular.module('gw-um-submission')
    .component('uiCollaborationNoteEditor', CollaborationNoteEditorComponent);
